import base from './base';

const primaryColor = '#0090d2';
const primary = '#0090d2';
const hover = '#f4c29a';
const errorColor = '#d71f28';

const hum4 = base({primaryColor, primary, hover, errorColor, base});
hum4.button.backgroundColor = '#f78e1e';
hum4.dateDropdown.padding = '15.6px 30px 12.4px 10px';

export default hum4;
